/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalySummaryAccount {
    getFixupPrototypeFunction() { return CostAnomalySummaryAccount.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalySummaryAccount>): CostAnomalySummaryAccount {
        let obj = Object.assign(new CostAnomalySummaryAccount(), model);
        CostAnomalySummaryAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalySummaryAccount>): CostAnomalySummaryAccount {
        if (!model) return null;
        return CostAnomalySummaryAccount.newInstance(<CostAnomalySummaryAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalySummaryAccount) {
        if (!obj) return;

        models.CostAnomalySummaryAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalySummaryAccount): boolean {
        Object.setPrototypeOf(obj, CostAnomalySummaryAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.bill_date === "string") {
            this.bill_date = new Date(<string><any>this.bill_date);
        }
        if (this.service_account_level_anomalies) {
            models.CostAnomalySummary.fixupPrototype(this.service_account_level_anomalies);
        }
        if (this.categories) {
            for (let val of this.categories) {
                models.CostAnomalyProductCategorySummary.fixupPrototype(val);
            }
        }
    }

    /**
     * service account id
     */
    cloud_account_id: string;

    /**
     * Time of results
     */
    bill_date: Date;

    /**
     * categories wise daily cost anomaly summary
     */
    categories: Array<models.CostAnomalyProductCategorySummary>;

    /**
     * Service account level anomalies
     */
    service_account_level_anomalies: models.CostAnomalySummary;

    /**
     * Records based on the actual metric that is used during anomaly detection
     */
    billing_source: string;

}
